import {useRef} from "react";
import {useVirtualizer} from "@tanstack/react-virtual";
import {AnankeDropdownItemCheckbox} from "@vesta/ananke/components/anankeDropdownItemCheckbox";

const ITEM_HEIGHT = 36;

export function VirtualizedFilterList({
    items,
    isSelected,
    onItemClick,
    renderItem,
}: {
    items: Array<string>;
    isSelected: (value: string) => boolean;
    onItemClick: (value: string) => void;
    renderItem: (value: string) => React.ReactNode;
}) {
    const parentRef = useRef<HTMLDivElement>(null);

    const virtualizer = useVirtualizer({
        count: items.length,
        getScrollElement: () => parentRef.current,
        estimateSize: () => ITEM_HEIGHT,
        overscan: 5,
    });

    return (
        <div
            ref={parentRef}
            className="w-full h-full overflow-auto"
        >
            <div
                style={{
                    height: `${virtualizer.getTotalSize()}px`,
                    width: "100%",
                    position: "relative",
                }}
            >
                {virtualizer.getVirtualItems().map((virtualItem) => {
                    const columnValue = items[virtualItem.index];
                    if (columnValue === undefined) {
                        return null;
                    }
                    const renderedItem = renderItem(columnValue);
                    const title = typeof renderedItem === "string" || typeof renderedItem === "number" ? String(renderedItem) : columnValue;
                    return (
                        <div
                            key={virtualItem.index}
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: `${virtualItem.size}px`,
                                transform: `translateY(${virtualItem.start}px)`,
                            }}
                        >
                            <AnankeDropdownItemCheckbox
                                id={columnValue}
                                isSelected={isSelected(columnValue)}
                                onClick={() => onItemClick(columnValue)}
                            >
                                <span
                                    className="block w-full truncate"
                                    title={title}
                                >
                                    {renderedItem}
                                </span>
                            </AnankeDropdownItemCheckbox>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
